import EmptyView from "@/core/components/EmptyView.vue";
import * as views from "../views";
/**
 * Hide thank you page & redirect to integrations
 */
export default [
  {
    path: "instant/:type",
    component: EmptyView,
    children: [
      {
        path: "",
        name: "InstantPages",
        component: views.Index,
        meta: {
          headerVisible: false,
          layoutIframe: true,
        }
      }
    ]
  }
];
